import axios from 'axios'
import library from '../../../utils/Library'

export const getAllGlobalNotificationEAuthz = async (
  id = null,
  appCodes = null
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('global_notification') +
    '/getAllGlobalNotificationEAuthz'

  const params = new URLSearchParams()
  id && params.append('id', id)

  appCodes &&
    appCodes.forEach((code) => {
      params.append('appCodes', code)
    })

  return await axios({
    url: `${URL}?${params.toString()}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
